import { render } from "./DropdownItemGroup.vue?vue&type=template&id=04385856"
const script = {}

import exportComponent from "/srv/airschedule.jetphix.com/releases/33/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__